import React from 'react'

const Copyright = () => {
  return (
    <div className='flex w-full py-5 pt-10 justify-center text-[14px] text-primaryBlack/50'>Copyright © 2023 Novelio Technologies Pvt. Ltd. </div>
  )
}

export default Copyright